document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('.mt-hero-slider__container');
  if (!container) return;
  
  // 防止重复初始化
  if (container.dataset.initialized === 'true') return;
  container.dataset.initialized = 'true';
  
  var slider = container.querySelector('.mt-hero-slider__slider');
  var originalSlides = Array.from(container.querySelectorAll('.mt-hero-slider__slide'));
  var leftBtn = container.querySelector('.mt-hero-slider__arrow--left');
  var rightBtn = container.querySelector('.mt-hero-slider__arrow--right');
  var dotsContainer = container.querySelector('.mt-hero-slider__dots');
  var autoplay = container.dataset.autoplay === 'true';
  var interval = parseInt(container.dataset.autoplay_interval || 5, 10) * 1000 || 5000;
  var timer = null;
  var progressTimer = null;
  var isAnimating = false;
  var progressBars = [];
  var progressStartTime = null;
  var isPaused = false;
  var currentAnimationFrame = null; // 用于控制requestAnimationFrame

  var peek = 224; // px
  var gap = 16; // px

  // 记录原始slide数量
  var realCount = originalSlides.length;
  
  // 克隆首尾slide
    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
    slider.appendChild(firstClone);
    slider.insertBefore(lastClone, originalSlides[0]);
    
    // 重新获取所有slides（包括克隆的）
  var slides = Array.from(container.querySelectorAll('.mt-hero-slider__slide'));
  var total = slides.length;
  var current = 1; // 初始定位到第1个真实slide

  // 初始化时设置第一个真实幻灯片为激活状态
  if (slides[current]) {
    slides[current].classList.add('active');
  }

  function getSlideWidth() {
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (vw < 750) {
      // 移动端：考虑容器左右margin，每边15px
      return vw - 30; // 视口宽度减去左右margin
    }
    return vw - (2 * peek) - (2 * gap);
  }

  function setSliderWidth() {
    // 每个slide固定像素宽度
    var w = getSlideWidth();
    slides.forEach(function(slide) {
      slide.style.width = w + 'px';
    });
    // 重新定位，防止宽度变化导致白屏
    setPosition(current, false);
  }
  setSliderWidth();
  window.addEventListener('resize', setSliderWidth);
  // 图片加载后也调用
  slides.forEach(function(slide) {
    var img = slide.querySelector('img');
    if (img) img.onload = setSliderWidth;
  });

  function offsetForIndex(idx) {
    var w = getSlideWidth();
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (vw < 750) {
      // 移动端：重新计算偏移量，考虑容器margin和gap
      // 容器左右各有15px margin，滑块gap为16px
      var containerMargin = 15; // 左右各15px
      var sliderGap = 16; // CSS中设置的gap
      
      // 移动端：滑块顺序为 [lastClone, slide1, slide2, ..., slideN, firstClone]
      // 第一张真实图片(index=1)应该显示在容器中央，偏移量应该是0
      // 后续图片应该向左移动（负偏移量），这样才能正确显示
      if (idx === 1) {
        // 第一张真实图片：不需要偏移，直接显示
        return 0;
      } else if (idx === 0) {
        // lastClone：显示最后一张真实图片，需要向左移动到第一张位置
        return -(realCount - 1) * (w + sliderGap);
      } else if (idx === total - 1) {
        // firstClone：显示第一张真实图片，需要向右移动到第一张位置
        return (realCount) * (w + sliderGap);
      } else {
        // 后续图片：向左移动，考虑滑块gap
        var offset = -(idx - 1) * (w + sliderGap);
        
        return offset;
      }
    }
    // 桌面端：滑块顺序为 [lastClone, slide1, slide2, ...]
    // slide_i 左边界 = i*(w+gap)
    // 让 slide_i 居中 => 其左边界 = (vw - w)/2
    var centerOffset = (vw - w) / 2;
    var x = centerOffset - (idx * (w + gap));
    return x; // 直接返回目标位移（px）
  }

  function setPosition(idx, withAnim = true) {
    // 真机优化：减少过渡时间，使用更简单的缓动函数
    slider.style.transition = withAnim ? 'transform 0.4s ease-out' : 'none';
    var tx = offsetForIndex(idx);
    slider.style.transform = 'translateX(' + tx + 'px)';
  }

  function goTo(idx, withAnim = true) {
    if (isAnimating && withAnim) {
      return;
    }
    
    // 验证索引范围
    if (idx < 0 || idx >= total) {
      return;
    }
    
    isAnimating = withAnim;
    
    // 立即切换遮罩层状态，与滑块移动同步
    slides.forEach(function(slide) {
      slide.classList.remove('active');
    });
    
    if (slides[idx]) {
      slides[idx].classList.add('active');
    }
    
    setPosition(idx, withAnim);
    current = idx;
    
    // 只在有动画时才更新进度条和启动动画
    if (withAnim) {
      updateProgressBars();
      // 延迟启动进度动画，等待slide切换完成
      setTimeout(function() {
        startProgressAnimation();
      }, 100);
    } else {
      // 如果没有动画，立即重置动画状态和更新进度条
      isAnimating = false;
      updateProgressBars();
    }
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function updateProgressBars() {
    // 如果进度条已经存在，只更新激活状态，不重新创建
    if (progressBars.length > 0) {
      var realIndex = getRealIndex();
      
      // 更新所有dot的激活状态和进度条宽度
      var dots = dotsContainer.querySelectorAll('.mt-hero-slider__dot');
      dots.forEach(function(dot, index) {
        var progressBar = progressBars[index];
        
        if (index === realIndex) {
          dot.classList.add('mt-hero-slider__dot--active');
          // 重置当前进度条宽度，准备开始动画
          progressBar.style.width = '0%';
        } else {
          dot.classList.remove('mt-hero-slider__dot--active');
          // 重置其他进度条宽度为0
          progressBar.style.width = '0%';
        }
      });
      
      return; // 直接返回，不重新创建
    }
    
    // 首次创建进度条
    dotsContainer.innerHTML = '';
    progressBars = [];
    
    for (let i = 0; i < realCount; i++) {
      var dot = document.createElement('button');
      dot.className = 'mt-hero-slider__dot' + (i === getRealIndex() ? ' mt-hero-slider__dot--active' : '');
      dot.setAttribute('aria-label', '切换到第' + (i + 1) + '张');
      dot.addEventListener('click', function () { goTo(i + 1); });
      
      // 创建进度条元素
      var progress = document.createElement('div');
      progress.className = 'mt-hero-slider__dot-progress';
      dot.appendChild(progress);
      
      progressBars.push(progress);
      dotsContainer.appendChild(dot);
    }
  }

  function getRealIndex() {
    if (current === 0) return realCount - 1;
    if (current === total - 1) return 0;
    return current - 1;
  }

  // 监听动画结束实现无缝跳转
  slider.addEventListener('transitionend', function (e) {
    // 确保是transform动画结束
    if (e.propertyName !== 'transform') return;
    
    if (current === 0) {
      // 跳转到最后一个真实slide
      current = realCount;
      setPosition(current, false);
      // 更新active类
      slides.forEach(function(slide) {
        slide.classList.remove('active');
      });
      if (slides[current]) {
        slides[current].classList.add('active');
      }
    } else if (current === total - 1) {
      // 跳转到第一个真实slide
      current = 1;
      setPosition(current, false);
      // 更新active类
      slides.forEach(function(slide) {
        slide.classList.remove('active');
      });
      if (slides[current]) {
        slides[current].classList.add('active');
      }
    }
    
    // 重置动画状态
    isAnimating = false;
    
    // 更新进度条
    updateProgressBars();
  });

  // 添加按钮事件监听器，增强错误处理
  if (leftBtn) {
    leftBtn.addEventListener('click', function() {
      if (isAnimating) {
        isAnimating = false;
      }
      prev();
    });
  }
  
  if (rightBtn) {
    rightBtn.addEventListener('click', function() {
      if (isAnimating) {
        isAnimating = false;
      }
      next();
    });
  }

  // 添加点击两侧预览区域切换功能
  function addPeekClickListeners() {
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    if (vw < 750) return; // 移动端不启用
    
    // 创建左右点击区域
    var leftClickArea = document.createElement('div');
    var rightClickArea = document.createElement('div');
    
    leftClickArea.style.cssText = `
      position: absolute;
      left: 0;
      top: 0;
      width: ${peek}px;
      height: 100%;
      z-index: 5;
      cursor: pointer;
    `;
    
    rightClickArea.style.cssText = `
      position: absolute;
      right: 0;
      top: 0;
      width: ${peek}px;
      height: 100%;
      z-index: 5;
      cursor: pointer;
    `;
    
    // 添加点击事件
    leftClickArea.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!isAnimating) {
        prev();
      }
    });
    
    rightClickArea.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!isAnimating) {
        next();
      }
    });
    
    // 添加到容器
    container.appendChild(leftClickArea);
    container.appendChild(rightClickArea);
    
    // 存储引用以便后续移除
    container.leftClickArea = leftClickArea;
    container.rightClickArea = rightClickArea;
  }
  
  // 移除点击区域
  function removePeekClickListeners() {
    if (container.leftClickArea) {
      container.leftClickArea.remove();
      container.leftClickArea = null;
    }
    if (container.rightClickArea) {
      container.rightClickArea.remove();
      container.rightClickArea = null;
    }
  }
  
  // 初始化时添加点击监听器
  addPeekClickListeners();
  
  // 窗口大小改变时重新设置
  window.addEventListener('resize', function() {
    removePeekClickListeners();
    setTimeout(addPeekClickListeners, 100); // 延迟确保resize完成
  });

  // 移动端触摸滑动功能
  var touchStartX = 0;
  var touchEndX = 0;
  var touchStartY = 0;
  var touchEndY = 0;
  var isTouching = false;
  var touchStartTime = 0;
  var initialTransform = 0;
  
  function isMobile() {
    var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return vw < 750;
  }
  
  function handleTouchStart(e) {
    if (!isMobile()) return;
    
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchStartTime = Date.now();
    isTouching = true;
    
    // 暂停自动播放
    pauseProgress();
    
    // 记录当前transform值
    var transform = slider.style.transform;
    var match = transform.match(/translateX\((.+?)px\)/);
    initialTransform = match ? parseFloat(match[1]) : 0;
    
    // 禁用过渡效果，使滑动更流畅
    slider.style.transition = 'none';
  }
  
  function handleTouchMove(e) {
    if (!isMobile() || !isTouching) return;
    
    touchEndX = e.touches[0].clientX;
    touchEndY = e.touches[0].clientY;
    
    var deltaX = touchEndX - touchStartX;
    var deltaY = touchEndY - touchStartY;
    
    // 如果是垂直滑动，不处理
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      return;
    }
    
    // 阻止默认滚动行为
    e.preventDefault();
    
    // 实时更新slider位置
    var newTransform = initialTransform + deltaX;
    slider.style.transform = 'translateX(' + newTransform + 'px)';
  }
  
  function handleTouchEnd(e) {
    if (!isMobile() || !isTouching) return;
    
    isTouching = false;
    var deltaX = touchEndX - touchStartX;
    var deltaY = touchEndY - touchStartY;
    var deltaTime = Date.now() - touchStartTime;
    
    // 如果是垂直滑动，不处理
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      // 恢复到原来的位置
      slider.style.transition = 'transform 0.4s ease-out';
      setPosition(current, false);
      resumeProgress();
      return;
    }
    
    // 恢复过渡效果
    slider.style.transition = 'transform 0.4s ease-out';
    
    // 判断滑动方向和距离
    var threshold = 50; // 最小滑动距离
    var velocity = Math.abs(deltaX) / deltaTime; // 滑动速度
    
    if (Math.abs(deltaX) > threshold || velocity > 0.5) {
      if (deltaX > 0) {
        // 向右滑动，显示上一张
        prev();
      } else {
        // 向左滑动，显示下一张
        next();
      }
    } else {
      // 滑动距离不够，回弹到当前位置
      setPosition(current, true);
      resumeProgress();
    }
    
    // 重置触摸坐标
    touchStartX = 0;
    touchEndX = 0;
    touchStartY = 0;
    touchEndY = 0;
  }
  
  // 添加触摸事件监听器
  slider.addEventListener('touchstart', handleTouchStart, { passive: false });
  slider.addEventListener('touchmove', handleTouchMove, { passive: false });
  slider.addEventListener('touchend', handleTouchEnd);
  slider.addEventListener('touchcancel', handleTouchEnd);

  function startProgressAnimation() {
    // 停止之前的进度动画
    if (progressTimer) {
      clearInterval(progressTimer);
      progressTimer = null;
    }
    
    // 如果没有开启自动播放，不启动进度动画
    if (!autoplay) {
      return;
    }
    
    var realIndex = getRealIndex();
    var currentProgressBar = progressBars[realIndex];
    
    if (!currentProgressBar) {
      return;
    }
    
    // 记录开始时间，确保第一遍轮播时间计算正确
    progressStartTime = Date.now();
    isPaused = false;
    
    // 重置当前进度条
    currentProgressBar.style.width = '0%';
    
    // 真机优化：使用setInterval减少计算频率，提高性能
    progressTimer = setInterval(function() {
      if (isPaused || !autoplay) {
        clearInterval(progressTimer);
        return;
      }
      
      var elapsed = Date.now() - progressStartTime;
      var progress = Math.min((elapsed / interval) * 100, 100);
      
      // 只更新当前进度条
      currentProgressBar.style.width = progress + '%';
    
      if (progress >= 100) {
        clearInterval(progressTimer);
        progressTimer = null;
        // 进度条完成时自动切换到下一张
        if (!isAnimating) {
          next();
        }
      }
    }, 50); // 每50ms更新一次，减少真机计算负担
  }

  function pauseProgress() {
    isPaused = true;
    if (progressTimer) {
      clearInterval(progressTimer);
    }
  }

  function resumeProgress() {
    startProgressAnimation();
  }


  // 初始化
    setPosition(1, false);
  updateProgressBars();
  
  // 添加动画状态监控定时器和位置检查
  var animationWatchdog = setInterval(function() {
    // 检查是否卡在动画状态超过3秒
    if (isAnimating) {
      setTimeout(function() {
        if (isAnimating) {
          console.log('Animation stuck, resetting...');
          isAnimating = false;
          // 重新定位到安全位置
          if (current < 1) {
            current = 1;
          } else if (current > realCount) {
            current = realCount;
          }
          setPosition(current, false);
          updateProgressBars();
          if (autoplay) {
            startProgressAnimation();
          }
        }
      }, 3000);
    }
    
    // 检查当前位置是否有效
    if (current < 0 || current >= total) {
      console.log('Invalid position detected, correcting...');
      current = Math.max(1, Math.min(current, realCount));
      setPosition(current, false);
      updateProgressBars();
    }
  }, 1000);
  
  // 延迟启动自动播放，确保页面完全加载
  if (autoplay) {
    setTimeout(function() {
      startProgressAnimation();
    }, 1000); // 延迟1000ms确保页面完全渲染和真机性能稳定
  }
  
});